import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cn } from '@ui/primitives/utils';
import { Search } from 'lucide-react';
/**
 * Loading display content.
 *
 * @param isLoading Error instance, uses as a render flag.
 * @param title Optional page title.
 * @param icon Optional custom alert icon.
 * @param className Optional root className.
 */ export const AlertLoading = (param)=>{
    let { isLoading, title = 'Loading...', icon, className } = param;
    if (!isLoading) {
        return null;
    }
    return /*#__PURE__*/ _jsxs("div", {
        className: cn('w-full text-muted-foreground/80 text-center px-2 py-10 text-sm rounded-md border border-border bg-muted', '[&>svg]:text-turquoise-500 [&>svg]:w-[35px] [&>svg]:h-[35px]', '[&>p]:font-normal [&>p]:text-sm [&>p]:leading-[120%] [&>p]:m-0', className),
        children: [
            icon !== null && icon !== void 0 ? icon : /*#__PURE__*/ _jsx(Search, {
                className: "mx-auto"
            }),
            /*#__PURE__*/ _jsx("p", {
                children: title
            })
        ]
    });
};
